import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResultadosService {

  private endPointResults:string = environment.apiResults;
  constructor(private http:HttpClient) { }

  /**
   * Header que contiene el token de autorizacion
   * @returns 
   */
  private getHeaders() {
    let accessToken = '';
    for (let a in localStorage) {
      if (a.endsWith('.accessToken'))
        accessToken = localStorage[a];
    }

    let headers_object = new HttpHeaders({
      'Content-Type': 'application/json',
       'Authorization': "Bearer "+ accessToken
    });
    return headers_object;
  }

  /**
   * Obtiene los resultados
   * @returns 
   */
  getResultados(tipo:string, idColaborador:number){
    let params = new HttpParams();
    let url = environment.apiResults;
    if(tipo == 'Jefes') {
      url += '/lider/nineboxtalent';
      params = params.append('idColaborador', idColaborador);
    }else if(tipo == 'Administradores') {
      url += '/admin/nineboxtalent';
    }

    return this.http.get(url, {params:params, headers:this.getHeaders()} ).pipe(
      tap(response => {
        if(response){
        }
      }),
      catchError(this.handleError)
    )
  }

  /**
  * Catch errors on call WS
  * @param error
  */
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ocurrió un error:', error.error.message);
    }
    return throwError(error);
  }
}
